import { render, staticRenderFns } from "./adSet.vue?vue&type=template&id=16385c27&scoped=true"
import script from "./adSet.vue?vue&type=script&lang=js"
export * from "./adSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16385c27",
  null
  
)

export default component.exports